// extracted by mini-css-extract-plugin
export default {"container":"style_container__83UxQ","exBox":"style_exBox__-BpRV","tableDetail":"style_tableDetail__2QwYS","dimentions":"style_dimentions__unDEU"};